module.exports = __webpack_public_path__ + "img/sys.9e99c9b9.png";